// start:ng42.barrel
import   './report-embed.directive';
// end:ng42.barrel

